export default "__VITE_ASSET__7b906070__"